import { createPool } from '@vercel/postgres';
import { useEffect, useState } from 'react';

import './Database.css';

const pool = createPool({
    connectionString: process.env.REACT_APP_POSTGRES_URL
});

async function send_results(name, score, duration) {
    await pool.sql`INSERT INTO results (player_name, score, game_duration) VALUES (${JSON.stringify(name)}, ${score}, ${duration});`;
}

async function load_results() {
    const { rows } = await pool.sql`SELECT player_name, score, game_duration FROM results ORDER BY score DESC, game_duration ASC LIMIT 100;`;
    return rows;
}

async function remove_tail() {
    await pool.sql`DELETE FROM results WHERE ctid NOT IN ( SELECT ctid FROM results ORDER BY score DESC, game_duration ASC LIMIT 200);`;
}

function LeaderRow({ position, title, score, time, highlight }) {

    const name = title.replace(/['"]+/g, '');
    let postitle = position;
    switch (position) {
        case 1:
            postitle = '🥇'
            break;
        case 2:
            postitle = '🥈'
            break;
        case 3:
            postitle = '🥉'
            break;
        default:
            postitle = `${position}: `
            break;
    }

    if (highlight)
        return (<h3>{postitle} <mark>{name}</mark> | Score {score} ({time} s)</h3>);

    return (<h3>{postitle} {name} | Score {score} ({time} s)</h3>);
}


export default function LeaderBoard({ playerName, data }) {
    const [leaders, setLeaders] = useState([]);
    let show_leaders = [];

    useEffect(() => {
        async function get_leaders() {
            const rows = await load_results();
            setLeaders(rows);
        }
        if (data.score === 0)
            get_leaders();
    }, [data.score]);


    useEffect(() => {
        async function send2db() {
            await send_results(playerName, data.score, data.gameDuration);
            await remove_tail();
        }
        if (data.isGameOver) {
            send2db();
        }
    }, [data.isGameOver]);

    const currentPlayer = {
        player_name: playerName,
        score: data.score,
        game_duration: data.gameDuration,
        me: true
    }

    show_leaders = leaders.concat([currentPlayer]);

    show_leaders.sort((a, b) => (b.score - a.score) || (a.game_duration - b.game_duration));
    const playerPosition = show_leaders.indexOf(currentPlayer)
    if (leaders.length == 0) {
        return (<>
            <h2>Leaderboard</h2>
            <div className='leaderboard'>
                <div className="loader"></div>
                <hr />
                <LeaderRow 
                    position={101} title={currentPlayer.player_name} 
                    score={currentPlayer.score} time={currentPlayer.game_duration} highlight={currentPlayer.me} />
            </div>
        </>);
    }

    if (playerPosition <= 9) {
        return (<>
            <h2>Leaderboard</h2>
            <div className='leaderboard'>
                {
                    show_leaders.slice(0, 10).map(({ player_name, score, game_duration, me }, idx) =>
                        <LeaderRow position={idx + 1} title={player_name} score={score} time={game_duration} highlight={me} />)
                }
            </div>
        </>);
    }

    // show_leaders = show_leaders
    const secondGroupIdx = (playerPosition === show_leaders.length - 1) ? playerPosition - 3 : playerPosition - 2
    return (<>
        <h2>Leaderboard</h2>
        <div className='leaderboard'>
            {
                show_leaders.slice(0, 5).map(({ player_name, score, game_duration, me }, idx) =>
                    <LeaderRow position={idx + 1} title={player_name} score={score} time={game_duration} highlight={me} />)
            }
            <hr />
            {
                show_leaders.slice(secondGroupIdx, playerPosition + 2).map(({ player_name, score, game_duration, me }, idx) =>
                    <LeaderRow position={secondGroupIdx + idx + 1} title={player_name} score={score} time={game_duration} highlight={me} />)
            }
        </div>
    </>);
}